import { APIgetPageFiles } from '../../../../api/Pages';

const pageFileRequestCache = new Map();
const pageFileRequestInflight = new Map();

const getPageFileRequestKey = (pageId, fileUuid) => `${pageId}:${fileUuid}`;

export const getPageFileByUuid = ({ pageId, fileUuid, fallbackFile = null }) => {
  if (!pageId || !fileUuid) {
    return Promise.resolve(fallbackFile);
  }

  const requestKey = getPageFileRequestKey(pageId, fileUuid);
  const cachedFile = pageFileRequestCache.get(requestKey);

  if (cachedFile) {
    return Promise.resolve(cachedFile);
  }

  const inflightRequest = pageFileRequestInflight.get(requestKey);
  if (inflightRequest) {
    return inflightRequest;
  }

  const request = APIgetPageFiles(pageId, [fileUuid])
    .then((response) => {
      const data = response.data?.data || [];
      const found = data.find((item) => item.uuid === fileUuid);

      if (found) {
        pageFileRequestCache.set(requestKey, found);
      }

      return found || fallbackFile;
    })
    .finally(() => {
      pageFileRequestInflight.delete(requestKey);
    });

  pageFileRequestInflight.set(requestKey, request);

  return request;
};

export const clearPageFileRequestCache = () => {
  pageFileRequestCache.clear();
  pageFileRequestInflight.clear();
};
